<div class="modal-content">
  <ng-container *ngIf="data.mode === 'rules'">
    <div class="modal-header">
      <h5 class="title-box">
        <i class="app-icon-fast-lightning" style="margin-right: 8px;"></i>
        Regras da Cotação Rápida
      </h5>
      <button type="button" class="close" data-dismiss="modal" (click)="close()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-md-12">
        Ao publicar a cotação rápida, alguns potenciais compradores receberão uma notificação para visualizar as
        características deste veículo.<br /><br />
        Caso esteja disposto a comprá-lo, o comprador fará uma oferta. Você recebe as ofertas e pode escolher a que
        desejar a qualquer momento. Ao comprador não é possível visualizar as ofertas dos outros
        compradores.<br /><br />
        Após o seu aceite a oferta que escolher, a fee plataforma é emitida pela Auto Arremate e assim que ele for pago, o
        valor será creditado com retorno.<br /><br />
        Mas fique atento: apesar de não haver obrigatoriedade em aceitar uma das propostas, criar cotações sem a
        intenção de aceitá-las pode levar compradores a deixarem de comprar seus veículos.
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="data.mode === 'cancel'">
    <div class="modal-header">
      <h5 class="title-box">
        <i class="app-icon-fast-lightning" style="margin-right: 8px;"></i>
        {{ (data.expirationTimeLeft > 0) ? 'CANCELAR COTAÇÃO RÁPIDA' : 'ABANDONAR COTAÇÃO RÁPIDA' }}
      </h5>
      <button type="button" class="close" data-dismiss="modal" (click)="close()">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <div class="col-md-12">
        Ao {{ (data.expirationTimeLeft > 0) ? 'cancelar' : 'abandonar' }} esta cotação rápida, todas as ofertas já
        recebidas serão automaticamente rejeitadas e os compradores serão avisados.
      </div>
      <button class="btn btn-primary btn-rounded btn-block mt-32" [disabled]="loading" (click)="cancelFastQuote()">
        <div class="btn-spinner float-left" *ngIf="loading"></div>
        <span>
          {{ (data.expirationTimeLeft > 0) ? 'CANCELAR COTAÇÃO RÁPIDA' : 'ABANDONAR COTAÇÃO RÁPIDA' }}
        </span>
      </button>
    </div>
  </ng-container>
</div>
